import { useEffect, useState, useMemo } from "react";
import Swal from "sweetalert2";
import Participaciones from "./Participaciones";

const CompraNumeros = ({dataInfo})=>{
    const [dataSorteo, setDataSorteo] = useState(null)
    const [dataUser, setDataUser] = useState(null)
    const [busqueda, setBusqueda] = useState('');
    const [numerosDisponibles, setNumerosDisponibles] = useState([]);
    const [seleccionados, setSeleccionados] = useState([]);
    const [cantidadAleatoria, setCantidadAleatoria] = useState(1); // Nueva variable para manejar la cantidad de números aleatorios
    const [pagoTotal, setPagoTotal] = useState(0)
    

    useEffect(()=>{
        if(dataInfo.data.sorteo.typeLot === 'Express'){
          dataInfo.cambioBoard('sorteoExpress')
        }
        setDataSorteo(dataInfo.data.sorteo)
        setDataUser(dataInfo.data.dataUser)
    },[])
    useEffect(()=>{ 
      setDataUser(dataInfo.data.dataUser)
    },[dataInfo.data.dataUser])
    
    useEffect(()=>{
        const posicion = dataInfo.data.dataSorteos.findIndex(obj => obj.id === dataInfo.data.sorteo.id);
        setDataSorteo(dataInfo.data.dataSorteos[posicion])
        setDataUser(dataInfo.data.dataUser)
        const puestos = dataInfo.data.dataSorteos[posicion].arryPuestos
        const NumerosVacios = puestos
            .filter(obj => Object.values(obj)[0] === '') 
            .map(obj => Object.keys(obj)[0]);
        setNumerosDisponibles(NumerosVacios)
    },[dataInfo.data.dataSorteos])

// Manejar selección/deselección de números
    const toggleSeleccion = (numero) => {
        setSeleccionados((prevSeleccionados) =>
        prevSeleccionados.includes(numero)
            ? prevSeleccionados.filter(n => n !== numero) // Deseleccionar
            : [...prevSeleccionados, numero] // Seleccionar
        );
    };

    // Filtrar números según la búsqueda
    const numerosFiltrados = numerosDisponibles.filter(numero =>
        numero.toString().includes(busqueda)
    );
    // console.log(dataSorteo.valor)
    
    useEffect(()=>{
      if(dataUser?.vendedor){
        const pagoTotalvendedor = seleccionados.length * (dataInfo.data.sorteo.valor * 0.9) ;
        setPagoTotal(pagoTotalvendedor)

      }else{
        const pagoTotalUser = seleccionados.length * dataInfo.data.sorteo.valor ;
        setPagoTotal(pagoTotalUser)
      }
    },[seleccionados])
    
    
    // Seleccionar números de forma aleatoria
    const seleccionarAleatorios = () => {
        if (cantidadAleatoria > numerosDisponibles.length) {
        Swal.fire(`Solo hay ${numerosDisponibles.length} números disponibles.`);
        return;
        }

        let seleccionAleatoria = [];
        while (seleccionAleatoria.length < cantidadAleatoria) {
        const numeroAleatorio = numerosDisponibles[Math.floor(Math.random() * numerosDisponibles.length)];
        if (!seleccionAleatoria.includes(numeroAleatorio)) {
            seleccionAleatoria.push(numeroAleatorio);
        }
        }
        setSeleccionados([...seleccionados, ...seleccionAleatoria]);
    };
    // Manejar la eliminación de un número seleccionado
    const eliminarSeleccionado = (numero) => {
        setSeleccionados((prevSeleccionados) =>
        prevSeleccionados.filter(n => n !== numero)
        );
    };
// Verificar si el pago es posible
    const verificarPago = () => {
      if (seleccionados.length === 0) {
        Swal.fire('Por favor, seleccione al menos un número.');
        return;
      }

      if (pagoTotal > dataUser.saldo) {
        Swal.fire('El pago total excede su saldo actual. Por favor, reduzca los números seleccionados o recargue su cuenta.');
      } else {
        Swal.fire({
          title: 'Confirmar Pago',
          text: `El monto de ${pagoTotal.toLocaleString('es-ES')} será descontado de su saldo. ¿Desea continuar?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            dataInfo.socket.emit('confirmarPago', {
              id: dataSorteo.id,
              seleccionados: seleccionados,
              uid: dataUser.uid,
              vendedor:dataUser?.vendedor||false
            });
            dataInfo.socket.on('responsConfirmarPago',(response)=>{
              Swal.fire(`${response.message}, su nuevo saldo es de: $${response.newSaldo}`)
              setSeleccionados([])
            })
          }
        });
      }
    };

    return(
        <div className="compraNumeros">
            {!!dataSorteo && !!dataUser && (
                <>
                    <h1 className="titulo">Selecciona los Números del Sorteo</h1>
                    <p className="descripcion">
                        A continuación, selecciona los números disponibles para el sorteo de <strong>{dataSorteo.premio}</strong>.
                        Cada número tiene un valor de {dataUser?.vendedor ? <><strong>${(dataSorteo.valor*0.9).toLocaleString('es-ES')}</strong> con un descuento del 10% como pago de comision de Vendedor</>: <strong>${dataSorteo.valor.toLocaleString('es-ES')}</strong> }. Actualmente, tienes un saldo de
                        <strong> ${dataUser.saldo.toLocaleString('es-ES')}</strong>. Haz clic en los números que deseas seleccionar.
                    </p>
                </>
            )}
            <input
            type="text"
            placeholder="Buscar número..."
            className="buscador"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
          <div className="aleatorio-container">
            <label htmlFor="cantidadAleatoria">Seleccionar números aleatorios: </label>
            <input
              className="input"
              type="number"
              id="cantidadAleatoria"
              min="1"
              max={numerosDisponibles.length}
              value={cantidadAleatoria}
              onChange={(e) => setCantidadAleatoria(Number(e.target.value))}
            />
            <button className="seleccionar-aleatorios" onClick={seleccionarAleatorios}>
              Seleccionar Aleatoriamente
            </button>
          </div>
          <div className="numeros-grid">
            {numerosFiltrados.map((numero, index) => (
              <div
                key={index}
                className={`numero ${seleccionados.includes(numero) ? 'seleccionado' : ''}`}
                onClick={() => toggleSeleccion(numero)}
              >
                {numero}
              </div>
            ))}
          </div>
          <div className="contador">
            <span>{seleccionados.length}</span> número(s) seleccionado(s). Pago total: <span>${pagoTotal.toLocaleString('es-ES')}</span>
          </div>
          <div className="numerosSeleccionados-container">
            <h2 className="numerosSeleccionados-titulo">Números Seleccionados</h2>
            <div className="numerosSeleccionados-grid">
              {seleccionados.length > 0 ? (
                seleccionados.map((numero, index) => (
                  <div
                    key={index}
                    className="numero-seleccionado"
                    onClick={() => eliminarSeleccionado(numero)}
                  >
                    {numero}
                  </div>
                ))
              ) : (
                <p className="no-seleccionados">No has seleccionado ningún número aún.</p>
              )}
            </div>
          </div>
          <div className="boton">
            <button className="verificar-pago" onClick={verificarPago}>
              Realizar Pago
            </button>
          </div>
          <div className="card">
                    <h3>Participaciones Activas en este sorteo</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Sorteo</th>
                                <th>Numeros activos</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                          {dataSorteo && (
                            <Participaciones data={{sorteo:dataSorteo, uid:dataInfo.data.dataUser.uid}}/>
                          )}
                        </tbody>
                    </table>
                </div>
        </div>
    )
}
export default CompraNumeros